import React from 'react';
import classNames from 'classnames';
import dropletIcon from '../../assets/water-droplet.png';

const Section = ({
  title,
  children,
  whiteText = false,
  backgroundImageUrl,
  classnameMain,
  transparent = false,
  ...rest
}) => {
  const wrapperClasses = classNames('section w-full py-12', classnameMain, {
    'bg-background': !backgroundImageUrl && !transparent,
  });
  const titleClasses = classNames('text-3xl mb-8 mx-2', {
    'text-white': whiteText,
    'text-blue-dark': !whiteText,
  });

  return (
    <div
      className={wrapperClasses}
      style={{
        background: backgroundImageUrl
          ? `url(${backgroundImageUrl}) no-repeat center center`
          : null,
        backgroundSize: 'cover',
      }}
      {...rest}
    >
      <div className="container mx-auto">
        {title && (
          <div
            className={titleClasses}
            style={{ fontFamily: 'Oswald, sans-serif', fontSize: '2rem' }}
          >
            <img
              src={dropletIcon}
              alt="Droplet Icon"
              className="inline-block mr-4"
            />
            <span>{title}</span>
          </div>
        )}
        <div>{children}</div>
      </div>
    </div>
  );
};

export default Section;
